export const OrganisationTokenQueryKeys = {
  all: () => ['organisationTokens'],
};
